import React, { useState } from "react";


export const itemWiseHeader = [
  {
    id: "ItemType",
    label: "Type",
    width: "100px",
    align: "left",

    required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
  },
  {
    id: "ItemCode",
    label: "Item Code",
    width: "80px",
    align: "left",
    required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
  },
  // {
  //   id: "ItemCode",
  //   label: "Item Code",
  //   width: 80,
  //   align: "left",

  //   required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
  // },
  {
    id: "ItemName",
    label: "Item  Name",
    width: "100px",
    align: "left",

    required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
  },
  {
    id: "Category",
    label: "Category",
    width: "100px",
    align: "left",

    required: "",
  },
  {
    id: "Unit",
    label: "Unit",
    width: "100px",
    align: "left",

    required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
  },
  {
    id: "hsnsaccode",
    label: "HSN/SAC Code",
    width: "100px",
    align: "left",

    required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
  },
  {
    id: "ShowItemInvoice",
    label: "Show Item in Invoice",
    width: "180px",
    align: "left",
    disableSort:true,
    required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
  },
  {
    id: "PurchaseAccountName",
    label: "Purchase A/C",
    width: "100px",
    align: "left",
    required:  <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
  },

  {
    id: "SalesAccountName",
    label: "Sales A/C",
    width: "100px",
    align: "left",
    required:  <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
  },
  {
    id: "TaxabilityCD",
    label: "Taxability",
    width: "100px",
    align: "right",
    required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
  },
  // {
  //   id: "UpdatePrice",
  //   label: "Update Price",
  //   width: 140,
  //   align: "right",
  //   required: "",
  // },
  {
    id: "DefaultPurchasePrice",
    label: "Net Purchase Price",
    width: "100px",
    align: "right",
    required: "",
  },
  {
    id: "DefaultSellingPrice",
    label: "Net Selling Price",
    width: "100px",
    align: "right",
    required: "",
  },
];

export const sellingPriceObj={
  isActive:"salesIsActive",
  activeType:"salesActiveType",
  priceType:"sellingPriceType",
  amount:"sellingAmount",
  DiscountType:"sellingdiscountType",
  DiscountValue:"Sellingdiscountvalue",
  gstRate:"sellingGstRate",
  effectivefrom:"sellingEffectiveFrom",
  effectiveto:"sellingEffectiveTo",
  discountAmt:"sellingdiscountAmt",
  amtaftdicount:"sellingamtaftdicount",
  cesstype:"sellingcesstype",
  cess:"sellingcess",
  amountIncludingGst:"sellingamountIncludingGst"

}
export const purchasePriceObj={
  isActive:"purchaseIsActive",
  activeType:"purchaseActiveType",
  priceType:"purchasePriceType",
  amount:"purchaseAmount",
  DiscountType:"purchaseDiscountType",
  DiscountValue:"purchaseDiscountvalue",
  gstRate:"purchaseGstRate",
  effectivefrom:"purchaseEffectiveFrom",
  effectiveto:"purchaseEffectiveTo",
  discountAmt:"purchasediscountAmt",
  amtaftdicount:"purchaseamtaftdicount",
  cesstype:"purchasecesstype",
  cess:"purchasecess",
    amountIncludingGst:"purchaseamountIncludingGst"
}


